import { MakeCall } from 'ha/services/apiV2/createMakeCall';

// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';
import {
  RequestUserDocumentResponse,
  UserDocumentCategory,
} from './types/UserDocument';

export type RequestUserDocumentPayload = (
  userId: 'me' | number,
  data: {
    category: UserDocumentCategory;
  },
) => Promise<{ data: RequestUserDocumentResponse }>;

export default (makeCall: MakeCall): RequestUserDocumentPayload => (
  userId,
  data,
) =>
  makeCall<RequestUserDocumentResponse>(
    'POST',
    `${APIV2_URL}/user/${userId}/document/request`,
    {
      data,
    },
  );
